export const GENERAL_DEBOUND_TIME = 300 // milliseconds
